import { Component, OnInit , Inject} from '@angular/core';
import{ FormControl, FormGroup, Validators} from '@angular/forms'
import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-rate-movie',
  templateUrl: './rate-movie.component.html',
  styleUrls: ['./rate-movie.component.css']
})
export class RateMovieComponent implements OnInit {
  Mycity:string="";
  Rated:boolean=false;
  NotRated:boolean=true;
  displayRatings:any='';
  
  constructor(private showcaseService:ShowcaseService, public dialogRef: MatDialogRef<RateMovieComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      movieId: String,
      moveDetails: any,
    }) { }

  ngOnInit(): void {
    if(this.data.moveDetails.userRating > 0){
      this.NotRated=false;
      this.Rated = true;
      this.displayRatings = this.data.moveDetails.userRating;
    }
  }
  loanApplicationForm=new FormGroup({
    city:new FormControl('',[Validators.required]),
    

  });
  get city(){
    return this.loanApplicationForm.get('city')

  }
  rateMovie( val:any){
    this.Rated=true;
    this.NotRated=false;
    this.displayRatings=val;
    console.warn(this.displayRatings)
    this.showcaseService.postRating(this.data.moveDetails.eventId, val).subscribe((res)=>{
    })
    
  }
  

}
